import restApi from '../../http.js'
import session from '../session'

export default class AuthApi {
  signIn(request) {
    return restApi({
      method: 'POST',
      url: '/auth/sign-in',
      data: {
        email: request.email,
        password: request.password
      },
      withCredentials: true // Allow cookies to be sent and received with the request
    })
  }

  resetPassword(request) {
    return restApi({
      method: 'POST',
      url: '/auth/reset-password',
      data: request
    })
  }

  forgotPassword(request) {
    return restApi({
      method: 'POST',
      url: '/auth/forgot-password',
      data: request
    })
  }

  getLoggedBrandInfo() {
    return restApi({
      method: 'GET',
      url: '/brands/my-id',
      headers: {
        Authorization: 'Bearer ' + session.getAccessToken()
      }
    })
  }

  signUpAsBrand(request) {
    return restApi({
      method: 'POST',
      url: '/brands/apply-to-sell',
      data: request
    })
  }

  signUpAsRetailer(request) {
    return restApi({
      method: 'POST',
      url: '/retailers/apply-to-buy',
      data: request
    })
  }

  verifyRetailer(request) {
    return restApi({
      method: 'POST',
      url: '/auth/retailer/verify',
      data: request
    })
  }

  verifyBrand(request) {
    return restApi({
      method: 'POST',
      url: '/auth/brand/verify',
      data: request
    })
  }

  verifyNewEmail(request) {
    return restApi({
      method: 'POST',
      url: '/auth/change-email',
      data: request
    })
  }

  refreshToken() {
    return restApi({
      // Don't include Authorization header here because a null token would trigger a 401 before the refresh
      method: 'POST',
      url: '/auth/refresh-token',
      withCredentials: true // Allow cookies to be sent and received with the request
    })
  }

  logout() {
    return restApi({
      method: 'POST',
      url: '/auth/sign-out',
      withCredentials: true
    })
  }

  setRefreshTokenInCookieForMigration() {
    return restApi({
      method: 'POST',
      url: '/data-migrations/user/set-refresh-token-in-cookie',
      headers: {
        Authorization: 'Bearer ' + session.getAccessToken()
      },
      withCredentials: true // Allow cookies to be sent and received with the request
    })
  }
}
